const sensitiveWords = [
    "河豚",
    "2p",
    "3p",
    "3级片",
    "4级片",
    "a级",
    "a片",
    "gay",
    "jj",
    "sm用品",
    "挨了一炮",
    "爱液",
    "爱液横流",
    "安眠药",
    "暴菊",
    "暴奶",
    "暴乳",
    "爆菊",
    "逼样",
    "毕业证",
    "避孕膜",
    "婊子",
    "操逼",
    "操比",
    "操蛋",
    "操了嫂",
    "操你",
    "操你妈",
    "操嫂子",
    "操他",
    "艹",
    "艹尼玛",
    "草泥马",
    "成人电",
    "成人卡通",
    "成人聊",
    "成人片",
    "成人视",
    "成人图",
    "成人文",
    "成人小",
    "赤裸",
    "充气娃",
    "出售肾",
    "处女膜",
    "传送答案",
    "春宫图",
    "春水横溢",
    "春药",
    "纯度白",
    "纯度黄",
    "次通过考",
    "催眠水",
    "催情粉",
    "催情药",
    "打标语",
    "打错门",
    "打飞机专",
    "打手",
    "大b",
    "大逼",
    "大花逼",
    "大鸡巴",
    "大妓院",
    "大揭露",
    "大奶子",
    "大肉棒",
    "代开",
    "代考",
    "弹簧刀",
    "弹夹",
    "弹种",
    "荡妇",
    "到花心",
    "盗号",
    "盗取qq",
    "盗取密码",
    "地震哥",
    "电狗",
    "电鸡",
    "东京热",
    "洞小口紧",
    "胴体",
    "毒蛇钻",
    "赌具",
    "躲猫猫",
    "二b",
    "二逼",
    "二奶大",
    "发春",
    "发浪",
    "发牌绝",
    "发票出",
    "发票代",
    "发票代开",
    "发票销",
    "发骚",
    "发票",
    "芳穴",
    "丰胸翘臀",
    "风骚",
    "夫妻交换",
    "妇销魂",
    "附送枪",
    "富姐",
    "富婆",
    "干你娘",
    "干扰器",
    "干死你",
    "肛",
    "肛交",
    "肛门是邻",
    "冈本真",
    "钢针狗",
    "钢珠枪",
    "港澳博球",
    "港马会",
    "港鑫华",
    "高潮",
    "高考黑",
    "高莺莺",
    "搞媛交",
    "根浴",
    "供应发票",
    "狗b",
    "狗操",
    "狗粮",
    "狗娘养的",
    "狗屁专家",
    "狗日的",
    "狗友",
    "乖乖粉",
    "滚圆大乳",
    "国际投注",
    "还会吹萧",
    "豪圈钱",
    "豪乳",
    "好帮手",
    "号屏蔽器",
    "合彩",
    "和狗交",
    "和狗性",
    "和狗做",
    "换妻",
    "换肾",
    "黄冰",
    "黄色电影",
    "黄色小电影",
    "回汉冲突",
    "慧聪",
    "昏药",
    "浑圆豪乳",
    "鸡巴",
    "鸡奸",
    "激光气",
    "激光汽",
    "激情电",
    "激情电话",
    "激情电影",
    "激情短",
    "激情交友",
    "激情妹",
    "激情炮",
    "激情视频",
    "激情小电影",
    "级办理",
    "级答案",
    "急需嫖",
    "集体打砸",
    "挤乳汁",
    "妓女",
    "寂寞少妇",
    "假币出售",
    "假发票",
    "假文凭",
    "假证件",
    "奸成瘾",
    "奸杀",
    "奸尸",
    "奸淫",
    "贱逼",
    "贱比",
    "贱货",
    "贱鸡",
    "贱人",
    "叫床",
    "叫自慰",
    "姐包夜",
    "姐服务",
    "姐兼职",
    "姐上门",
    "禁片",
    "禁网禁片",
    "精液",
    "精子射在",
    "就爱插",
    "就要色",
    "菊暴",
    "菊爆",
    "菊花洞",
    "巨波",
    "巨乳",
    "口交",
    "口手枪",
    "口淫",
    "烂逼",
    "烂比",
    "浪穴",
    "老虎机",
    "六he彩",
    "六合",
    "六合采",
    "六合彩",
    "乱奸",
    "乱伦",
    "乱伦类",
    "乱伦小",
    "伦理大",
    "伦理电影",
    "伦理毛",
    "伦理片",
    "轮手枪",
    "裸聊",
    "裸聊网",
    "裸女",
    "裸体",
    "裸舞视",
    "裸戏",
    "裸照",
    "妈逼",
    "妈了个逼",
    "麻将透",
    "麻醉弹",
    "麻醉狗",
    "麻醉枪",
    "麻醉药",
    "吗啡",
    "买枪",
    "买肾",
    "卖逼",
    "卖比",
    "卖地财政",
    "卖发票",
    "卖枪",
    "卖身",
    "卖肾",
    "卖血",
    "毛一鲜",
    "美乳",
    "美艳少妇",
    "妹按摩",
    "妹上门",
    "门按摩",
    "门保健",
    "门服务",
    "闷骚",
    "蒙汗药",
    "蒙汗药粉",
    "咪咪",
    "迷幻型",
    "迷幻药",
    "迷昏口",
    "迷昏药",
    "迷魂香",
    "迷魂药",
    "迷奸药",
    "迷情水",
    "迷情药",
    "迷药",
    "谜奸药",
    "密码",
    "蜜穴",
    "蜜液",
    "免电灯",
    "摩小姐",
    "母乳家",
    "母子乱伦",
    "男奴",
    "内射",
    "嫩逼",
    "嫩穴",
    "嫩阴",
    "你的西域",
    "你妈的",
    "娘两腿之间",
    "妞上门",
    "浓精",
    "虐畜",
    "虐待",
    "虐猫",
    "女激情",
    "女奴",
    "女人和狗",
    "女任职名",
    "女上门",
    "女士服务",
    "女伟哥",
    "女优",
    "泡友",
    "炮的小蜜",
    "陪考枪",
    "陪聊",
    "喷尿",
    "屁眼",
    "嫖俄罗",
    "嫖鸡",
    "破处",
    "强暴",
    "强奸",
    "氢弹手",
    "清除负面",
    "清纯壆",
    "情聊天室",
    "情妹妹",
    "情色",
    "情杀",
    "情视频",
    "情欲",
    "求肾",
    "去你妈的",
    "犬交",
    "群p",
    "群奸",
    "群奸暴",
    "群交",
    "人弹",
    "人兽",
    "人体艺",
    "人游行",
    "日你",
    "日你妈",
    "日死你",
    "日赚",
    "容弹量",
    "柔胸粉",
    "肉棒",
    "肉洞",
    "肉缝",
    "肉棍",
    "乳房",
    "乳沟",
    "乳交",
    "乳头",
    "乳晕",
    "骚妇",
    "骚货",
    "骚浪",
    "骚妹",
    "骚女",
    "骚蹄子",
    "骚穴",
    "骚妖",
    "骚嘴",
    "色电影",
    "色妹妹",
    "色情",
    "色情电影",
    "色情片",
    "色视频",
    "色图",
    "色小说",
    "色诱",
    "色欲",
    "杀手",
    "傻逼",
    "上门激",
    "上我",
    "少妇自拍",
    "射精",
    "呻吟",
    "肾源",
    "生殖器",
    "失身",
    "失身水",
    "手榴弹",
    "手木仓",
    "手枪",
    "手淫",
    "兽交",
    "熟妇",
    "双峰",
    "双沟",
    "双乳",
    "吮吸",
    "丝护士",
    "丝情侣",
    "丝袜保",
    "丝袜恋",
    "丝袜美",
    "丝袜妹",
    "丝袜网",
    "丝足按",
    "私处",
    "私房写真",
    "私服",
    "缩阴",
    "体透视镜",
    "替人体",
    "天葬",
    "透视器",
    "透视眼睛",
    "臀沟",
    "脱衣艳",
    "外透视镜",
    "外围赌球",
    "猥亵",
    "小电影",
    "小鸡鸡",
    "小口径",
    "小穴",
    "新金瓶",
    "性爱",
    "性爱日",
    "性伴侣",
    "性服务",
    "性福情",
    "性感少",
    "性伙伴",
    "性交",
    "性奴",
    "性奴集中营",
    "性虐",
    "性虐待",
    "性推广歌",
    "性息",
    "性游戏",
    "性欲",
    "学骚乱",
    "学位证",
    "学生妹",
    "颜射",
    "阳具",
    "恙虫病",
    "摇头丸",
    "要射精了",
    "要射了",
    "要泄了",
    "夜激情",
    "一通健康法",
    "一肖",
    "一小撮别",
    "一夜激情",
    "一夜情",
    "遗情书",
    "阴唇",
    "阴道",
    "阴蒂",
    "阴户",
    "阴间来电",
    "阴茎",
    "阴毛",
    "阴水",
    "淫荡",
    "淫妇",
    "淫贱",
    "淫乱",
    "淫靡",
    "淫魔舞",
    "淫情女",
    "淫肉",
    "淫骚妹",
    "淫兽",
    "淫兽学",
    "淫水",
    "淫娃",
    "淫穴",
    "淫欲",
    "隐蔽式摄像机",
    "隐形喷剂",
    "隐形摄像机",
    "婴儿命",
    "婴儿汤",
    "罂粟壳",
    "罂粟籽",
    "咏妓",
    "幽谷三",
    "游精佑",
    "有偿服务",
    "有偿捐献",
    "有偿肾",
    "有码",
    "有奶不一",
    "幼齿类",
    "幼交",
    "诱奸",
    "鱼虾蟹骰子",
    "娱乐透视",
    "与狗性",
    "玉蒲团",
    "玉体",
    "育部女官",
    "欲火",
    "鸳鸯洗",
    "援交",
    "约炮",
    "晕倒型",
    "韵徐娘",
    "杂种",
    "招妓",
    "找男",
    "找女",
    "找援交",
    "罩杯",
    "贞操",
    "植物冰",
    "殖器护",
    "制服诱",
    "中华昆仑女神功",
    "自摸",
    "自慰",
    "自慰用",
    "总会美女",
    "足交",
    "醉迷药",
    "醉乙醚",
    "尊爵粉",
    "作爱",
    "唑仑",
    "做爱",
    "领导",
    "习",
    "近",
    "平",
    "做爱小",
    "做台"
]

export default sensitiveWords

export const isIncludeSensitive = (word) => {
    return sensitiveWords.some(item => word.indexOf(item) > -1)
}